// HOST MAP

export const INT_HOST_LIST = ["intapi", "10.1.18.12", "localhost"];

export const STG_HOST_LIST = [
  "stguigp",
  "10.222.212.183",
  "10.222.212.184",
  "10.111.76.33",
  "10.111.75.33",
];
